import { Icon } from "@iconify/react/dist/iconify.js";
import { brand } from "../../../context";
import { NotificationBanner } from "../../banners/NotificationBanner";

type InitialSetupProps = {
  // onUpload: () => void;
  // onFillForm: () => void;
  onChat: () => void;
};

export function InitialSetup({ onChat }: InitialSetupProps) {
  return (
    <div className="InitialSetup grid gap-3 content-center items-center">
      {/* MIKI Plus AI Agent Update Banner */}
      <NotificationBanner
        variant="info"
        title="A new and improved MIKI Plus AI Agent is now available. Please feel free to try the new chat functionality."
        description={
          <p>
            Thank you for your patience as we enhance your experience.
            <ul>
              <li className="list-disc">
                Optionally, you can now <strong>upload a document</strong> to the chat to help the
                agent understand your request better.
              </li>
              <li className="list-disc">
                Before generating a quotation request, the agent will present you with a{" "}
                <strong>summary</strong> of your request.
              </li>
              <li className="list-disc">
                You can always <strong>go back to the chat</strong> to make changes to your request.
              </li>
            </ul>
          </p>
        }
        className="col-span-3 mb-4"
      />
      <div className="grid gap-3 content-center items-center col-span-3">
        {/* <div className="border border-gray-100 rounded-md shadow-md p-3 text-center cursor-pointer grid gap-3 place-items-center">
          <Icon
            icon="material-symbols:file-upload"
            className="text-5xl border border-gray-200 rounded-md p-3"
          />
          <span>I have a quotation request document to upload</span>
          <button className="Button" type="button" data-brand={brand} onClick={onUpload}>
            Upload Document
          </button>
        </div>
        <div className="border border-gray-100 rounded-md shadow-md p-3 text-center cursor-pointer grid gap-3 place-items-center">
          <Icon
            icon="material-symbols:description"
            className="text-5xl border border-gray-200 rounded-md p-3"
          />
          <span>I have a quotation request form to fill</span>
          <button className="Button" type="button" data-brand={brand} onClick={onFillForm}>
            Fill Form
          </button>
        </div> */}
        <div className="border border-gray-100 rounded-md shadow-md p-3 text-center cursor-pointer grid gap-3 place-items-center relative">
          <Icon
            icon="material-symbols:new-releases"
            className="absolute top-0 left-0 text-green-500 text-3xl translate-x-[-25%] translate-y-[-25%]"
          />
          <Icon
            icon="material-symbols:chat"
            className="text-5xl border border-gray-200 rounded-md p-3"
          />
          <span>I want to chat for a quotation request</span>
          <button className="Button" type="button" data-brand={brand} onClick={onChat}>
            Chat
          </button>
        </div>
      </div>
    </div>
  );
}
